import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  href?: string;
  size?: 'lg' | 'xl';
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text,
  href = '#',
  size = 'lg',
  className = '',
  onClick
}: CTAButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-semibold transition-all duration-200 rounded-full relative overflow-hidden group cursor-pointer hover:scale-[1.02] active:scale-[0.98]';
  const sizeClasses = size === 'xl' ? 'px-8 py-4 text-xl md:text-2xl' : 'px-6 py-3 text-lg';
  const colorClasses = 'bg-[var(--accent-amber)] text-[#070b14] hover:bg-[var(--accent-amber-hover)] shadow-lg shadow-[var(--accent-amber)]/20 hover:shadow-xl hover:shadow-[var(--accent-amber)]/30';
  const handleClick = (e: React.MouseEvent) => {
    if (href.startsWith('#') && href.length > 1) {
      e.preventDefault();
      const targetId = href.slice(1);
      requestAnimationFrame(() => {
        const target = document.getElementById(targetId);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    }
    onClick?.();
  };
  return <a href={href} onClick={handleClick} className={`${baseClasses} ${sizeClasses} ${colorClasses} ${className}`} data-id="element-214">
      <span className="relative z-10" data-id="element-215">{text}</span>
      <ArrowRight className="ml-2 w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-216" />
    </a>;
}